import React from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { useAudioPlayer } from '../pages/Main/components/useAudioPlayer'
import { AUDIO_MINI_GAME_URL } from '../constants/audioAssets'

function isMiniGameRoute(pathname: string): boolean {
  return pathname === '/eclipsera-bonds'
}

/**
 * BGM for the Onet Connect mini-game page (`/eclipsera-bonds`).
 * Uses the same settings as PvP / start / kingdom: background music toggle + music volume.
 */
export const MiniGameMusicPlayer: React.FC = () => {
  const location = useLocation()
  const backgroundMusicEnabled = useSelector((state: RootState) => state.app.settings.backgroundMusicEnabled)
  const musicVolume = useSelector((state: RootState) => state.app.settings.musicVolume)
  const musicDucked = useSelector((state: RootState) => state.app.settings.musicDucked)

  const onMiniGame = isMiniGameRoute(location.pathname)
  const shouldPlay = backgroundMusicEnabled && onMiniGame && !musicDucked

  const audioRef = useAudioPlayer({
    backgroundMusicEnabled: shouldPlay,
    musicVolume,
  })

  return (
    <audio
      ref={audioRef}
      src={AUDIO_MINI_GAME_URL}
      loop
      preload="metadata"
      onError={(e) => {
        console.error('Mini-game music loading error:', e)
      }}
    />
  )
}
